<ng-container *transloco="let t">
<div class="modal-header">
  <h5 class="modal-title d-flex align-items-center">{{ t('portal.verification.creditAuthorization') }}</h5>
  <button
    type="button"
    class="btn-close"
    (click)="activeModal.close(false)"
    [attr.aria-label]="t('common.close')"
  ></button>
</div>

<div class="modal-body">
  <div [innerHTML]="creditAuthText" class="mb-4">
  </div>
  <form #creditAuthForm="ngForm" novalidate>
    <div class="row">
      <div class="form-check ms-2">
        <input class="form-check-input" [(ngModel)]="isCreditAuthChecked" type="checkbox" value="" id="isCreditAuthChecked" name="isCreditAuthChecked">
        <label class="form-check-label" for="isCreditAuthChecked">
          {{ t('portal.verification.iWeAuthorize') }}
        </label>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-sm btn-secondary"
    (click)="activeModal.close(false)"
    data-bs-dismiss="modal"
  >
    {{ t('common.cancel') }}
  </button>
  <button
    type="button"
    class="btn btn-sm bp-primary-bg-color"
    (click)="activeModal.close(true)"
    data-bs-dismiss="modal"
    [disabled]="!isCreditAuthChecked"
  >
    {{ t('portal.verification.accept') }}
  </button>
</div>
</ng-container>
